import { render, staticRenderFns } from "./CapturaDocumentosFotoSelfie.vue?vue&type=template&id=1a447b1a&scoped=true&"
import script from "./CapturaDocumentosFotoSelfie.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosFotoSelfie.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosFotoSelfie.vue?vue&type=style&index=0&id=1a447b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a447b1a",
  null
  
)

export default component.exports